<div class="row">
    <div class="col-md-6 col-lg-6 col-xl-5 col-12 mx-auto">
        <div *ngIf="!showType" class="text-center">
            <div class="mb-3">
                <img style="width:86px;height:auto" src="/assets/logo.png" class="img">
            </div>
            <div class="mb-1 fs-4 fw-bold">
                WPPSI
            </div>
            <div class="text-muted" style="white-space: pre-wrap;">
                {{data.info}}
            </div>
            <div class="btn-group">
                <div class="btn-item">
                    <button (click)="showType='visual-spatial-index';getData('WPPSI-Visual-Spatial-Index');" class="btn flex-column gap-3">
                        <div class="d-flex align-items-center justify-content-center bg-pink function">
                            <i class="material-icons">extension</i>
                        </div>
                        <div class="fw-bold">
                            Visual Spatial
                        </div>
                        <div class="border arrow d-flex align-items-center justify-content-center rounded-circle">
                            <i class="material-icons icon-pink">
                                arrow_forward
                            </i>
                        </div>
                    </button>
                </div>
                <div class="btn-item">
                    <button (click)="showType='processing-speed-index';getData('WPPSI-Processing-Speed-Index');" class="btn flex-column gap-3">
                        <div class="d-flex align-items-center justify-content-center bg-yellow function">
                            <i class="material-icons">speed</i>
                        </div>
                        <div class="fw-bold">
                            Processing Speed
                        </div>
                        <div class="border arrow d-flex align-items-center justify-content-center rounded-circle">
                            <i class="material-icons icon-yellow">
                                arrow_forward
                            </i>
                        </div>
                    </button>
                </div>
            </div>
            <div class="mt-4 d-flex mb-2 text-start">
                <div class="card bg-light rounded-4 w-100">
                    <div class="card-body p-1">
                        <div class="disclaimer">
                            <div class="d-flex align-items-center px-1">
                                <div class="pe-3">
                                    <img src="/assets/disclaimer.svg">
                                </div>
                                <div>
                                    <div class="fw-bold">Disclaimer</div>
                                    <div class="text-muted font-book">
                                        Primary Index in WPPSI consist of 5 parameter: Verbal comprehension, Visual spatial, Fluid reasoning, Working memory, & Processing speed.
                                        This trial only previews Visual Spatial & Processing Speed
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="showType" class="d-flex position-relative show-type text-center flex-column justify-content-center">
            <div class="mb-3">
                <img style="width:86px;height:auto" src="/assets/logo.png" class="img">
            </div>
            <div class="mb-1">
                <div [ngSwitch]="showType" class="fs-4 fw-bold">
                    <span *ngSwitchCase="'visual-spatial-index'">Visual Spatial</span>
                    <span *ngSwitchCase="'processing-speed-index'">Processing Speed</span>
                </div>
            </div>
            <div class="text-muted" style="white-space: pre-wrap;">
                {{data.info}}
            </div>
            <div class="pt-5 px-md-5">
                <a [class.disabled]="isStarted!=1" class="btn btn-start w-100" routerLink="{{showType}}">
                    {{isStarted!=1?'Test hasn\'t started yet':'Start'}}
                </a>
            </div>
        </div>
    </div>
</div>
